import { Outlet } from "react-router-dom";

export default function PrivateCleanLayout() {
  return <Outlet />;
}
